/**
 * Адреса, открытые туром (макет training.js, trainingInterrupted): страница шага -- просмотр
 * урока, а не самостоятельная практика, в том числе после выхода из тура на ней, после «Назад»
 * браузера к прежнему шагу и после перезагрузки. Отметки живут в sessionStorage вкладки и
 * снимаются, когда пользователь сам уходит на адрес, которого тур не открывал. Без хранилища
 * (запрет браузера) отметки живут в памяти вкладки.
 */

const KEY = 'qhdspm.training.tour-pages';

/** Предел отметок: самый длинный урок -- 43 шага */
const MAX_PAGES = 64;

/** Отметки на случай, когда sessionStorage недоступен */
let fallback: string[] = [];

function read(): string[] {
	try {
		const raw = sessionStorage.getItem(KEY);
		if (raw === null) return [];
		const parsed: unknown = JSON.parse(raw);
		return Array.isArray(parsed)
			? parsed.filter((value): value is string => typeof value === 'string')
			: [];
	} catch {
		return fallback;
	}
}

function write(pages: string[]): void {
	try {
		if (pages.length === 0) sessionStorage.removeItem(KEY);
		else sessionStorage.setItem(KEY, JSON.stringify(pages));
	} catch {
		fallback = pages;
	}
}

/** Тур открыл этот адрес (путь и параметры) */
export function markTourPage(href: string): void {
	const pages = read();
	if (!pages.includes(href)) write([...pages, href].slice(-MAX_PAGES));
}

export function isTourPage(href: string): boolean {
	return read().includes(href);
}

/** Пользователь на адресе вне тура: прежние отметки больше не нужны */
export function leaveTourPages(href: string): void {
	const pages = read();
	if (pages.length > 0 && !pages.includes(href)) write([]);
}
